import { render, staticRenderFns } from "./coursecandidate.vue?vue&type=template&id=2d66cdcd&"
import script from "./coursecandidate.vue?vue&type=script&lang=js&"
export * from "./coursecandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports